import _objectSpread from "/var/www/pontevedra4picos.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/var/www/pontevedra4picos.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/var/www/pontevedra4picos.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { clsx, cssClass, hasWindow, makeComposePrefix } from "../utils.js";
import { useEventCallback } from "../hooks/index.js";
import { useEvents } from "../contexts/index.js";
import { ErrorIcon, LoadingIcon } from "./Icons.js";
import { activeSlideStatus, ELEMENT_ICON, IMAGE_FIT_CONTAIN, IMAGE_FIT_COVER, SLIDE_STATUS_COMPLETE, SLIDE_STATUS_ERROR, SLIDE_STATUS_LOADING, SLIDE_STATUS_PLACEHOLDER } from "../consts.js";
var slidePrefix = makeComposePrefix("slide");
var slideImagePrefix = makeComposePrefix("slide_image");
export var ImageSlide = function ImageSlide(_ref) {
  var image = _ref.slide,
    offset = _ref.offset,
    render = _ref.render,
    rect = _ref.rect,
    imageFit = _ref.imageFit,
    onClick = _ref.onClick,
    onLoad = _ref.onLoad,
    style = _ref.style;
  var _a, _b, _c, _d, _e, _f, _g;
  var _React$useState = React.useState(SLIDE_STATUS_LOADING),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    status = _React$useState2[0],
    setStatus = _React$useState2[1];
  var _useEvents = useEvents(),
    publish = _useEvents.publish;
  var imageRef = React.useRef(null);
  React.useEffect(function () {
    if (offset === 0) {
      publish(activeSlideStatus(status));
    }
  }, [offset, status, publish]);
  var handleLoading = useEventCallback(function (img) {
    if (status === SLIDE_STATUS_COMPLETE) {
      return;
    }
    ("decode" in img ? img.decode() : Promise.resolve()).catch(function () {}).then(function () {
      if (!img.parentNode) {
        return;
      }
      setStatus(SLIDE_STATUS_COMPLETE);
      onLoad === null || onLoad === void 0 ? void 0 : onLoad(img);
    });
  });
  var setImageRef = React.useCallback(function (img) {
    imageRef.current = img;
    if (img === null || img === void 0 ? void 0 : img.complete) {
      handleLoading(img);
    }
  }, [handleLoading]);
  var handleOnLoad = React.useCallback(function (event) {
    handleLoading(event.currentTarget);
  }, [handleLoading]);
  var onError = React.useCallback(function () {
    setStatus(SLIDE_STATUS_ERROR);
  }, []);
  var cover = image.imageFit === IMAGE_FIT_COVER || image.imageFit !== IMAGE_FIT_CONTAIN && imageFit === IMAGE_FIT_COVER;
  var nonInfinite = function nonInfinite(value, fallback) {
    return Number.isFinite(value) ? value : fallback;
  };
  var maxWidth = nonInfinite(Math.max.apply(Math, _toConsumableArray(((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map(function (x) {
    return x.width;
  })) !== null && _b !== void 0 ? _b : []).concat(image.width ? [image.width] : []))), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
  var maxHeight = nonInfinite(Math.max.apply(Math, _toConsumableArray(((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map(function (x) {
    return x.height;
  })) !== null && _e !== void 0 ? _e : []).concat(image.height ? [image.height] : []))), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
  var defaultStyle = maxWidth && maxHeight ? {
    maxWidth: "min(".concat(maxWidth, "px, 100%)"),
    maxHeight: "min(".concat(maxHeight, "px, 100%)")
  } : {
    maxWidth: "100%",
    maxHeight: "100%"
  };
  var srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.sort(function (a, b) {
    return a.width - b.width;
  }).map(function (item) {
    return "".concat(item.src, " ").concat(item.width, "w");
  }).join(", ");
  var estimateActualWidth = function estimateActualWidth() {
    return rect && !cover && image.width && image.height ? rect.height / image.height * image.width : Number.MAX_VALUE;
  };
  var sizes = srcSet && rect && hasWindow() ? "".concat(Math.round(Math.min(estimateActualWidth(), rect.width)), "px") : undefined;
  return React.createElement(React.Fragment, null, React.createElement("img", {
    ref: setImageRef,
    onLoad: handleOnLoad,
    onError: onError,
    onClick: onClick,
    className: clsx(cssClass(slideImagePrefix()), cover && cssClass(slideImagePrefix("cover")), status !== SLIDE_STATUS_COMPLETE && cssClass(slideImagePrefix("loading"))),
    draggable: false,
    alt: image.alt,
    style: _objectSpread({}, defaultStyle, style),
    sizes: sizes,
    srcSet: srcSet,
    src: image.src
  }), status !== SLIDE_STATUS_COMPLETE && React.createElement("div", {
    className: cssClass(slidePrefix(SLIDE_STATUS_PLACEHOLDER))
  }, status === SLIDE_STATUS_LOADING && ((render === null || render === void 0 ? void 0 : render.iconLoading) ? render.iconLoading() : React.createElement(LoadingIcon, {
    className: clsx(cssClass(ELEMENT_ICON), cssClass(slidePrefix(SLIDE_STATUS_LOADING)))
  })), status === SLIDE_STATUS_ERROR && ((render === null || render === void 0 ? void 0 : render.iconError) ? render.iconError() : React.createElement(ErrorIcon, {
    className: clsx(cssClass(ELEMENT_ICON), cssClass(slidePrefix(SLIDE_STATUS_ERROR)))
  }))));
};